import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";

export default function Admin1() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check if user was previously authenticated
  useEffect(() => {
    const authStatus = localStorage.getItem("admin_authenticated");
    if (authStatus === "true") {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem("admin_authenticated", "true");
  };

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0E1525]">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#3485e4] border-t-transparent"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Admin Dashboard | Ecoplace Tours</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {isAuthenticated ? (
        <AdminDashboard />
      ) : (
        <AdminLogin onLogin={handleLogin} />
      )}
    </>
  );
}